import { Grid } from "@mui/material";

export const SettingContainer = ({ children }) => {
    return (
        <Grid container direction="row" justifyContent="flex-start" spacing={0} alignContent={"flex-start"}>
            {children}
        </Grid>
    )
}

export default SettingContainer;